module.exports = __webpack_public_path__ + "static/media/dotauditIcon.21461164.svg";